import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth";
import { ErrorBanner } from "../components/ui";

export function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  return (
    <div className="min-h-screen flex flex-col bg-tora-paper">
      {/* ブランドトップ strip (画像リファレンス準拠) */}
      <header className="bg-white border-b-2 border-tora">
        <div className="mx-auto max-w-7xl px-4 py-2">
          <img
            src="/logo-header.jpg"
            alt="令和の虎 経営塾"
            className="h-10 md:h-12 w-auto"
          />
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-4 py-10">
        <form
          className="card w-full max-w-md p-6 md:p-8 shadow-md"
          onSubmit={async (e) => {
            e.preventDefault();
            setErr(null);
            setBusy(true);
            try {
              await login(email, password);
              nav("/", { replace: true });
            } catch (e) {
              setErr((e as Error).message ?? "ログインに失敗しました");
            } finally {
              setBusy(false);
            }
          }}
        >
          <p className="text-[11px] text-tora tracking-widest font-semibold">
            MEMBER SIGN IN
          </p>
          <h1 className="text-2xl md:text-3xl font-bold text-tora-ink mt-1.5">
            会員ログイン
          </h1>
          <p className="text-sm text-tora-ink/70 mt-1 mb-6">
            登録メールアドレスとパスワードでログインしてください。
          </p>

          <div className="mb-4">
            <label className="label" htmlFor="email">
              メールアドレス
            </label>
            <input
              id="email"
              type="email"
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              autoCapitalize="off"
              autoCorrect="off"
              spellCheck={false}
              inputMode="email"
              autoFocus
              placeholder="例: yamada@example.com"
            />
          </div>
          <div className="mb-4">
            <label className="label" htmlFor="password">
              パスワード
            </label>
            <input
              id="password"
              type="password"
              className="input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={8}
              autoComplete="current-password"
            />
          </div>
          {err && <ErrorBanner className="mb-3">{err}</ErrorBanner>}
          <button className="btn-primary btn-lg w-full" disabled={busy}>
            {busy ? "ログイン中…" : "ログイン →"}
          </button>
          <p className="mt-5 text-center">
            <Link
              to="/password-reset"
              className="text-sm text-tora hover:underline"
            >
              パスワードをお忘れの方
            </Link>
          </p>
        </form>
      </main>
    </div>
  );
}
